






























































































































	import { Component, Vue, Prop } from "vue-property-decorator";
	import {
  		SelectedCountry,
  		RedCapital
	} from "@/configuration";
	import API from "@/api";

	@Component({
  		metaInfo() {
    		return {
				title: 'RedCapital | Ingreso de Clave',
				htmlAttrs: {
					// @ts-ignore
					lang: RedCapital[SelectedCountry].Lang
				}
    		};
  		},
		data() {
			return {
				RedCapital, // por definir
				SelectedCountry, // por definir
				canPress: true,
				isButtonClickable: false,
				stateToken: null,
				stateToken2: null,
				error: null,
				modal:{
					mensaje: null,
					showModal: false,
					img: null
				},
				validacionData: {
					rut_empresa: null,
					usuario_id: null,
				},
				form: {
					siiPassword: null,
					siiRePassword: null,
				},
				siiPassword: {
					prim: {
						props: {
							name: 'siiPassword',
							label: 'Contraseña SII',
							type: 'password',
							required: true,
							solo: true, 
							outline: true,
						},
						style: {
							lineHeight: '2',
							marginTop: '0 !important'
						},
						rules: {
							password: [(v: any) => !!v || "La contraseña es requerida"],
						}
					},
					conf: {
						props: {
							name: 'siiPasswordConf',
							label: 'Repetir Contraseña SII',
							type: 'password',
							required: true,
							solo: true, 
							outline: true
						},
						rules: {
							required: true,
							confirmed: 'siiPassword'
						}
					}
				},

				rules: {
					password: [(v: any) => !!v || "La contraseña es requerida"],
					rePassword: [
						(v: any) => {
							if(v != this.$data.form.siiPassword){ 
								return "Las contraseñas no coinciden"
							}
						} 
					],
				},
				
			};
		},
		beforeMount() { 
			setTimeout(() => {
			API.validarTokenEmpresa(this.$props.token)
				.then((res: any) =>{
					this.$data.stateToken = true;
					this.$data.validacionData.rut_empresa = res.data.rut_empresa;
					this.$data.validacionData.usuario_id = res.data.usuario_id;	
				}).catch( e => {
					// Token Expirado
					this.$data.stateToken2 = true;
				});
			},10);
		},
		computed: {
			compareSiiPass() {
				if(this.$data.form.siiPassword != null && this.$data.form.siiRePassword != null){
					if(this.$data.form.siiPassword != "" && this.$data.form.siiRePassword != ""){
						if (this.$data.form.siiPassword === this.$data.form.siiRePassword){
							return true
						}else{
							return false
						}
					}else{
						return false
					}	
				}else{
					return false;
				}
			}
		},
		methods: {
    		async onSubmit() {
				this.$data.canPress = false;
				var data = {
					clavesii : this.$data.form.siiPassword,
					empresa_rut: this.$data.validacionData.rut_empresa,
					user_id: this.$data.validacionData.usuario_id,
					token: this.$props.token
				}
				// @ts-ignore
				API.cambiarClaveSii(data)
				.then((res: any) =>{
					// @ts-ignore
					this.showModalExito();
				}).catch( e => {
					this.$data.canPress = true;
					if(e.response.data.message != '' || e.response.data.message != null){
						// @ts-ignore
						this.showModal(e.response.data.message);
					}else{
						// @ts-ignore
						this.showModal('En estos momentos no podemos procesar tu solicitud.<br>Intente nuevamente.');
					}
				})
			},
			showModalExito(){
				this.$data.modal.showModal = true;
				this.$data.modal.mensaje = 'Tu contraseña se ha guardado exitosamente';
				this.$data.modal.img = '/images/claveSii/ico_checkPass.png';
				setTimeout(() => {
					this.$data.modal.showModal = false;
					this.$data.modal.mensaje = null;
					this.$data.modal.img = null;
					this.$router.push({
						path: "/"
					});
				},3000);
			},
			showModalError(){
				this.$data.modal.showModal = true;
				this.$data.modal.mensaje = 'Las contraseñas no coinciden.<br>Intente nuevamente.';
				this.$data.modal.img = '/images/claveSii/ico_errPass.png';
			},
			showModal(msj){
				this.$data.modal.showModal = true;
				this.$data.modal.mensaje = msj;
				this.$data.modal.img = '/images/claveSii/ico_errPass.png';
			},
			lostFocus(){
				setTimeout(() =>{
					// @ts-ignore
					if(!this.compareSiiPass){
						// @ts-ignore
						this.showModalError()
					}
				},400);
			}
		} 
	})

	export default class ClaveSiiProject extends Vue {
		@Prop() token!: number;
	}
